import { GridLayout as FoundationGridLayout, foundationGridLayoutTemplate as zeroGridLayoutTemplate, foundationGridLayoutStyles as zeroGridLayoutStyles, foundationGridLayoutShadowOptions as zeroGridLayoutShadowOptions, defaultGridLayoutConfig, } from '@genesislcap/foundation-ui';
/**
 * @tagname %%prefix%%-grid-layout
 */
export class GridLayout extends FoundationGridLayout {
}
/**
 * The Zero Grid Layout
 *
 * @public
 * @remarks
 * HTML Element: \<zero-grid-layout\>
 */
export const zeroGridLayout = GridLayout.compose(Object.assign({ baseName: 'grid-layout', shadowOptions: zeroGridLayoutShadowOptions, styles: zeroGridLayoutStyles, template: zeroGridLayoutTemplate }, defaultGridLayoutConfig));
